import {Injectable} from '@angular/core';
import {Mapper} from '../../../core/abstracts/mapper.abstract';
import {AvailableColumnResponse} from '../model/available-columns.respose';
import {AvailableReportColumn} from '../model/available-report-column.model';

@Injectable({providedIn: 'root'})
export class AvailableReportColumnResponseMapper extends Mapper<AvailableColumnResponse, AvailableReportColumn> {

  override map(source: AvailableColumnResponse): AvailableReportColumn {
    return new AvailableReportColumn(
      source.column,
      source.name,
      source.fieldType
    )
  }
}
